import React, { useState } from "react";
import { useFines } from "../hooks/useFines";
import { usePay } from "../hooks/usePay";
import { FormatCurrency } from "../hooks/usePay";
import { startPayment } from '../services/FinesServices';
import { LoadingModalPlates } from "./ModalLoad";
import { AnimatePresence } from "framer-motion";

interface PagoIframeProps {
  enlace: string;
  montoTotal: number;
  descuentos: number;
  totalPagar: number;
}

export const PagoIframe: React.FC<PagoIframeProps> = ({ montoTotal, descuentos, totalPagar }) => {

    const { trafficTickets } = useFines();
    const { removePayLink, payLinkMateria } = usePay();
    const [loading, setLoading] = useState<boolean>(false);


      const handlePayment = async () => {
    if (!trafficTickets) return;

    setLoading(true);
    await startPayment(trafficTickets.order);

    const formData = {
      s_transm: trafficTickets.order,
      c_referencia: trafficTickets.reference,
      mp_signature: payLinkMateria?.hash,
      t_importe: trafficTickets.amount?.toFixed(2),
      t_servicio: "1244",
      val_1: trafficTickets.reference,
      val_2: "0",
      mp_autosubmit_time: "1000",
    };

    const form = document.createElement("form");
    form.method = "POST";
        form.action = "https://www.adquiramexico.com.mx/clb/endpoint/gmty/"//https://www.adquiramexico.com.mx/clb/endpoint/gmty/";
    form.style.display = "none";

    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value ?? "";
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
    setLoading(false);
  };

  return (
    <div className="flex justify-center px-1 pt-1 pb-1 bg-gray-200/15">
      <AnimatePresence>
        {loading && <LoadingModalPlates onClose={() => setLoading(false)} />}
      </AnimatePresence>

      <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-black mb-6">
          Resumen de Pago {trafficTickets?.fines?.[0]?.placa ? `- ${trafficTickets.fines[0].placa}` : ""}
        </h2>

        <div className="space-y-3 text-base sm:text-lg">
          <div className="flex flex-col sm:flex-row sm:justify-between border-b pb-2">
            <span className="font-medium text-gray-700 mb-1 sm:mb-0">Referencia:</span>
            <span className="font-bold text-gray-900 break-words text-sm sm:text-base max-w-full sm:max-w-xs text-right">
              {trafficTickets?.reference ?? "N/A"}
            </span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="font-medium text-gray-700">Monto Total:</span>
            <span className="font-bold text-gray-900">{FormatCurrency(montoTotal)}</span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="font-medium text-gray-700">Descuentos:</span>
            <span className="font-bold text-red-600">-{FormatCurrency(descuentos)}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-700">Total a Pagar:</span>
            <span className="font-bold text-green-600">{FormatCurrency(totalPagar)}</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 mt-8">
          <button
            type="button"
            onClick={removePayLink}
            className="flex-1 bg-red-500 text-white py-2 rounded-lg hover:bg-red-600 transition"
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            type="button"
                            onClick={handlePayment}
            className={`flex-1 text-white py-2 rounded-lg transition ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
            disabled={loading}
          >
            Proceder al Pago
          </button>
        </div>
      </div>
    </div>
  );
};
